// @ts-nocheck
import React from "react";
import { FaPhoneAlt, FaMapMarkerAlt, FaClock, FaFacebookF, FaInstagram } from "react-icons/fa";
import { useLanguageContext } from "../context/languageContext";
import businessConfig from "../config/business";

/**
 * Contact card at the foot of the menu.
 *
 * Deliberately quiet: a neutral card with a thin brand edge rather than a large
 * block of colour, so it reads as practical information and not as an advert.
 * The name and tagline are already on the welcome banner, so they are not repeated.
 */
export const SubBanner = () => {
    const { t } = useLanguageContext();

    return (
        <section className="px-4 pt-2 pb-6">
            <div className="rounded-2xl bg-white border border-slate-200/70 shadow-[0_2px_12px_-8px_rgba(0,0,0,0.15)] overflow-hidden">
                <div className="h-[3px] bg-brand"></div>

                <div className="p-4 space-y-3.5">
                    <div className="flex items-center gap-3">
                        <img
                            src={businessConfig.logo}
                            alt={businessConfig.name}
                            className="w-9 h-9 rounded-full object-contain flex-shrink-0"
                        />
                        <div className="min-w-0">
                            <p className="text-[13px] font-bold text-slate-900 leading-tight truncate">
                                {businessConfig.legalName}
                            </p>
                            <p className="text-[10px] font-black uppercase tracking-[0.15em] text-slate-400">
                                {t("businessBadge", businessConfig.badge)}
                            </p>
                        </div>
                    </div>

                    <div className="space-y-2 pt-0.5">
                        <a
                            href={businessConfig.mapsUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-start gap-2.5 text-slate-600 active:text-brand transition-colors"
                        >
                            <FaMapMarkerAlt className="text-brand mt-[3px] flex-shrink-0" size={11} />
                            <span className="text-[11.5px] font-medium leading-snug">{businessConfig.address}</span>
                        </a>
                        <div className="flex items-center gap-2.5 text-slate-600">
                            <FaClock className="text-brand flex-shrink-0" size={11} />
                            <span className="text-[11.5px] font-medium">
                                {t("Open Daily", "Open Daily")} · {businessConfig.hours}
                            </span>
                        </div>
                    </div>

                    <div className="flex items-center gap-2 pt-0.5">
                        <a
                            href={`tel:+${businessConfig.phoneRaw}`}
                            className="flex-1 h-10 rounded-xl bg-brand text-white flex items-center justify-center gap-2 text-[11px] font-black uppercase tracking-widest active:scale-[0.98] transition-transform"
                        >
                            <FaPhoneAlt size={11} />
                            {businessConfig.phone}
                        </a>
                        <a
                            href={businessConfig.social.facebook}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Facebook"
                            className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl border border-slate-200 text-slate-500 active:scale-95 transition-transform"
                        >
                            <FaFacebookF size={13} />
                        </a>
                        <a
                            href={businessConfig.social.instagram}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Instagram"
                            className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl border border-slate-200 text-slate-500 active:scale-95 transition-transform"
                        >
                            <FaInstagram size={14} />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
